import Handlebars from 'handlebars'

// Utility: normalize values passed to helpers
// - Flattens arrays, trims strings, filters empty when compact=true
// - Supports unique and limit options
function normalizeValues(raw: any[], opts: { compact?: boolean; unique?: boolean; limit?: number }) {
  const compact = opts.compact !== false
  const flat = (raw as any[])
    .flat(Infinity)
    .filter((v) => v !== undefined && v !== null)
    .map((v) => String(v).trim())
  const cleaned = compact ? flat.filter((v) => v !== '') : flat
  const uniq = opts.unique ? Array.from(new Set(cleaned)) : cleaned
  if (typeof opts.limit === 'number') return uniq.slice(0, opts.limit)
  return uniq
}

// Register Handlebars helpers once globally
if (!Handlebars.helpers.join) {
  // Usage: {{join a b c separator=", " prefix="(" suffix=")" wrapLeft="[" wrapRight="]" unique=true compact=true limit=3}}
  Handlebars.registerHelper('join', (...args: any[]) => {
    const options = args.pop()
    const { separator = ' | ', prefix = '', suffix = '', wrapLeft = '', wrapRight = '', unique = false, compact = true, limit } = options?.hash || {}
    const values = normalizeValues(args, { unique, compact, limit })
    if (values.length === 0) return ''
    const core = values.join(separator)
    const wrapped = `${wrapLeft}${core}${wrapRight}`
    const out = `${prefix}${wrapped}${suffix}`
    return new (Handlebars as any).SafeString(out)
  })
}

if (!Handlebars.helpers.concat) {
  Handlebars.registerHelper('concat', (...args) => {
    const [key, value] = args
    if (!value) return ''
    return `${key} ${value}`
  })
}

if (!Handlebars.helpers.literal) {
  Handlebars.registerHelper('literal', (value) => value)
}

if (!Handlebars.helpers.ps) {
  // Usage: {{{ps a b c separator="/" left="[" right="]" prefix="" suffix="" unique=true compact=true}}}
  Handlebars.registerHelper('ps', (...args: any[]) => {
    const options = args.pop()
    const { separator = '/', left = '[', right = ']', prefix = '', suffix = '', unique = false, compact = true, limit } = options?.hash || {}
    const values = normalizeValues(args, { unique, compact, limit })
    if (values.length === 0) return ''
    const inner = values.join(separator)
    const out = `${prefix}${left}${inner}${right}${suffix}`
    return new (Handlebars as any).SafeString(out)
  })
}

if (!Handlebars.helpers['dash-join']) {
  // Usage: {{{dash-join a b c separator=" | " prefix="- " suffix="" unique=true compact=true}}}
  Handlebars.registerHelper('dash-join', (...args: any[]) => {
    const options = args.pop()
    const { separator = ' | ', prefix = '- ', suffix = '', unique = false, compact = true, limit } = options?.hash || {}
    const values = normalizeValues(args, { unique, compact, limit })
    if (values.length === 0) return ''
    const inner = values.join(separator)
    const out = `${prefix}${inner}${suffix}`
    return new (Handlebars as any).SafeString(out)
  })
}

if (!Handlebars.helpers.rn) {
  // Usage: {{{rn modelNumber partNumber brand separator=" " prefix="" suffix="" unique=true compact=true limit=5}}}
  // Example: {{rn modelNumber partNumber}} → "Apple A1316 MG2323 Apple A1316 Apple MG2323"
  Handlebars.registerHelper('rn', (...args: any[]) => {
    const options = args.pop()
    const { separator = ' ', left = '', right = '', prefix = '', suffix = '', unique = false, compact = true, limit } = options?.hash || {}
    const values = normalizeValues(args, { unique, compact, limit })
    if (values.length === 0) return ''
    const inner = values.join(separator)
    const out = `${prefix}${left}${inner}${right}${suffix}`
    return new (Handlebars as any).SafeString(out)
  })
}

export const DEFAULT_NAME_TEMPLATE = "{{brand}} {{model}} {{{rn modelNumber partNumber}}} {{{ps cpu ram storage color}}}"
export const DEFAULT_DESCRIPTION_TEMPLATE = "{{ps cpu ram storage color}} {{{dash-join operatingSystem releaseData screen camera sim carrier battery dimensions (concat 'weight:' weight)}}}"

export const HB = Handlebars
